import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
const apiKey = process.env.REACT_APP_API_KEY;
const adminApiKey = process.env.REACT_APP_ADMIN_API_KEY;

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = process.env.REACT_APP_API_URL;
const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL;
const LANDING_API_URL = process.env.REACT_APP_LANDING_API_URL;

const encryptKey = (plainText) => {
  const key = CryptoJS.SHA256(SECRET_KEY);
  const iv = CryptoJS.lib.WordArray.random(16);
  const encrypted = CryptoJS.AES.encrypt(plainText, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const ivBase64 = CryptoJS.enc.Base64.stringify(iv);
  return ivBase64 + ":" + encrypted.toString();
};

const getEncryptedWithTimestamp = (keyValue) => {
  const timestamp = Date.now();
  return encryptKey(`${keyValue}:${timestamp}`);
};

const generateEncryptedApiKey = () => getEncryptedWithTimestamp(apiKey);
const generateEncryptedAdminApiKey = () =>
  getEncryptedWithTimestamp(adminApiKey);

let currentEncryptedApiKey = null;
let currentEncryptedAdminApiKey = null;

const getCurrentApiKey = () => {
  if (!currentEncryptedApiKey) {
    currentEncryptedApiKey = generateEncryptedApiKey();
  }

  return currentEncryptedApiKey;
};

const getCurrentAdminApiKey = () => {
  if (!currentEncryptedAdminApiKey) {
    currentEncryptedAdminApiKey = generateEncryptedAdminApiKey();
  }

  return currentEncryptedAdminApiKey;
};

const refreshApiKey = () => {
  currentEncryptedApiKey = generateEncryptedApiKey();
  return currentEncryptedApiKey;
};

const refreshAdminApiKey = () => {
  currentEncryptedAdminApiKey = generateEncryptedAdminApiKey();
  return currentEncryptedAdminApiKey;
};

const getDefaultHeaders = () => ({
  "Content-Type": "application/json",
  Accept: "application/json",
  "ADMIN-API-KEY": getCurrentAdminApiKey(),
  "Accept-Language":
    typeof window !== "undefined" && localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en",
});

const getSeedersDefaultHeaders = () => ({
  "Content-Type": "application/json",
  Accept: "application/json",
  "API-KEY": getCurrentApiKey(),
});

export {
  API_BASE_URL,
  API_URL,
  ADMIN_API_URL,
  LANDING_API_URL,
  generateEncryptedApiKey,
  generateEncryptedAdminApiKey,
  getCurrentApiKey,
  getCurrentAdminApiKey,
  getDefaultHeaders,
  getSeedersDefaultHeaders,
  refreshApiKey,
  refreshAdminApiKey,
};
